import { Answer, AnswerResult, Question } from '@/models/Question';
import { Questionnaire } from '@/models/Questionnaire';
import { AxiosError } from 'axios';
import { action } from 'typesafe-actions';
import { QuestionnaireTypes } from './types';

export const listQuestionnairesRequest = (classEnrollmentId: number, evaluationId: number | undefined, personId: number | undefined) =>
    action(QuestionnaireTypes.LIST_QUESTIONNAIRES_REQUEST, { classEnrollmentId, evaluationId, personId });
export const listQuestionnairesSuccess = (questionnaires: Questionnaire[]) => action(QuestionnaireTypes.LIST_QUESTIONNAIRES_SUCCESS, questionnaires);
export const listQuestionnairesFailure = (error: AxiosError) => action(QuestionnaireTypes.LIST_QUESTIONNAIRES_FAILURE, error);

export const generateQuestionnaireRequest = (evaluationId: number, lessonId: number, attemptNumber: number, classEnrollmentId: number) =>
    action(QuestionnaireTypes.GENERATE_QUESTIONNAIRE_REQUEST, { evaluationId, lessonId, attemptNumber, classEnrollmentId });
export const generateQuestionnaireFailure = (error: AxiosError) => action(QuestionnaireTypes.GENERATE_QUESTIONNAIRE_FAILURE, error);

export const getQuestionnaireRequest = (questionnaireId: number) => action(QuestionnaireTypes.GET_QUESTIONNAIRE_REQUEST, questionnaireId);
export const getQuestionnaireSuccess = (questionnaire: Questionnaire) => action(QuestionnaireTypes.GET_QUESTIONNAIRE_SUCCESS, questionnaire);
export const getQuestionnaireFailure = (error: AxiosError) => action(QuestionnaireTypes.GET_QUESTIONNAIRE_FAILURE, error);

export const getQuestionRequest = (questionnaireId: number, questionId: number) =>
    action(QuestionnaireTypes.GET_QUESTION_REQUEST, { questionnaireId, questionId });
export const getQuestionSuccess = (question: Question) => action(QuestionnaireTypes.GET_QUESTION_SUCCESS, question);
export const getQuestionFailure = (error: AxiosError) => action(QuestionnaireTypes.GET_QUESTION_FAILURE, error);
export const getQuestionClear = () => action(QuestionnaireTypes.GET_QUESTION_CLEAR);

export const updateAnswerRequest = (questionnaireId: number, answer: Answer) =>
    action(QuestionnaireTypes.UPDATE_ANSWER_REQUEST, { questionnaireId, answer });
export const updateAnswerSuccess = (answer: Answer) => action(QuestionnaireTypes.UPDATE_ANSWER_SUCCESS);
export const updateAnswerFailure = (error: AxiosError) => action(QuestionnaireTypes.UPDATE_ANSWER_FAILURE, error);

export const finishQuestionnaireRequest = (questionnaireId: number) => action(QuestionnaireTypes.FINISH_QUESTIONNAIRE_REQUEST, questionnaireId);

export const finishQuestionnaireSuccess = () => action(QuestionnaireTypes.FINISH_QUESTIONNAIRE_SUCCESS);
export const finishQuestionnaireFailure = (error: AxiosError) => action(QuestionnaireTypes.FINISH_QUESTIONNAIRE_FAILURE, error);

export const getQuestionnaireResponseSummaryRequest = (questionnaireId: number) =>
    action(QuestionnaireTypes.GET_QUESTIONNAIRE_RESULT_REQUEST, questionnaireId);
export const getQuestionnaireResponseSummarySuccess = (responseSummary: AnswerResult[]) =>
    action(QuestionnaireTypes.GET_QUESTIONNAIRE_RESULT_SUCCESS, responseSummary);
export const getQuestionnaireResponseSummaryFailure = (error: AxiosError) => action(QuestionnaireTypes.GET_QUESTIONNAIRE_RESULT_FAILURE, error);

export const clearQuestionnaireStore = () => action(QuestionnaireTypes.CLEAR_QUESTIONNAIRE_STORE);

export const startQuestionnaireRequest = (data: number) => action(QuestionnaireTypes.START_QUESTIONNAIRE_REQUEST, data);
export const startQuestionnaireSuccess = (data: Questionnaire) => action(QuestionnaireTypes.START_QUESTIONNAIRE_SUCCESS, data);
export const startQuestionnaireFailure = (error: AxiosError) => action(QuestionnaireTypes.START_QUESTIONNAIRE_FAILURE, error);
